export default __webpack_public_path__ + "assets/models/899e50d62f5556b148df52f7cd0617c4.glb";